import React from "react";

export const PLATFORM_ACCESS_HELP_TITLE = "Acesso à plataforma e renovação";

export function PlatformAccessHelpContent({ planAccess }) {
  const courtesyDays = planAccess ? planAccess.courtesy_days : 10;
  const dataRetentionDays = 30;

  return (
    <>
      <p>
        <strong>Contagem regressiva</strong> — o número ao lado do nome da fazenda
        mostra quantos dias restam de <strong>acesso total</strong> à plataforma web
        (período pago + dias extras). Assim, sempre que você abrir o sistema, verá
        quanto tempo ainda tem de uso.
      </p>

      <p>
        <strong>+{courtesyDays} dias extras</strong> — após o vencimento do plano
        pago, a plataforma <strong>não corta o acesso de imediato</strong>. Permanece
        aberta por mais {courtesyDays} dias para que a operação não pare enquanto a
        renovação é feita. Isso <strong>não é cortesia gratuita</strong>: ao pagar
        novamente, o valor cobre também o período em que continuou usando após o
        vencimento.
      </p>

      <p>
        <strong>Apps e rastreamento</strong> — os aplicativos de campo e os
        rastreadores continuam enviando dados à plataforma por mais{" "}
        <strong>{dataRetentionDays} dias</strong> após o vencimento do plano. Se
        você renovar dentro desse prazo, os dados permanecem disponíveis. Após
        {dataRetentionDays} dias sem renovação, o histórico deixa de ser mantido
        para consulta.
      </p>

      <p>
        <strong>Data fixa de renovação</strong> — a cobrança segue sempre o{" "}
        <strong>dia em que o plano começou</strong>, e não o dia em que você efetua
        o pagamento. Mesmo pagando durante os {courtesyDays} dias extras, a próxima
        mensalidade conta a partir da data original do ciclo.
      </p>

      <p>
        <strong>Exemplo</strong>
      </p>
      <ul>
        <li>
          Plano contratado em <strong>31/01</strong> — acesso pago até{" "}
          <strong>28/02</strong> (ou 29/02).
        </li>
        <li>
          Com <strong>+{courtesyDays}</strong>, a plataforma web fica aberta até
          cerca de <strong>10/03</strong> sem interrupção.
        </li>
        <li>
          Se você pagar em <strong>05/03</strong>, o novo ciclo começa em{" "}
          <strong>01/03</strong> (dia seguinte ao vencimento pago),{" "}
          <strong>não</strong> em 05/03.
        </li>
        <li>
          A próxima cobrança será em <strong>31/03</strong> — sempre ancorada no
          dia <strong>31</strong> de cada mês, como no primeiro pagamento.
        </li>
        <li>
          Os apps seguem enviando telemetria até{" "}
          <strong>{dataRetentionDays} dias</strong> após 28/02; renovando antes
          disso, nada se perde.
        </li>
      </ul>

      <p>
        Passe o mouse sobre o contador no topo da tela para ver as datas exatas
        do seu plano (vencimento pago, fim do acesso e próxima renovação).
      </p>
    </>
  );
}
